import { useEffect } from 'react';
import { API_ORIGIN } from '../utils/homeHelpers';

const useApiVersionSync = ({ fetchUserStats, fetchGamification }) => {
  useEffect(() => {
    let aborted = false;

    (async () => {
      try {
        const url = `${API_ORIGIN}/api/healthz`;
        const r = await fetch(url, { credentials: 'include', cache: 'no-store' });
        const j = await r.json().catch(() => null);

        if (!j || !j.ok) return;

        const v = String(j.version || 'dev-local');
        const prev = typeof localStorage !== 'undefined'
          ? (localStorage.getItem('api:version') || '')
          : '';

        if (v && v !== prev) {
          try {
            try { localStorage.removeItem('lbCacheV1'); } catch {}
            try { localStorage.removeItem('gami:cache'); } catch {}
            try { localStorage.removeItem('userStats:cache'); } catch {}

            if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
              try {
                const regs = await navigator.serviceWorker.getRegistrations();
                for (const reg of regs) {
                  try { await reg.unregister(); } catch {}
                }
              } catch {}
            }

            if (typeof caches !== 'undefined' && caches?.keys) {
              try {
                const keys = await caches.keys();
                for (const k of keys) {
                  try { await caches.delete(k); } catch {}
                }
              } catch {}
            }

            try { localStorage.setItem('api:version', v); } catch {}

            if (!aborted) {
              try { await fetchUserStats(); } catch {}
              try { await fetchGamification(); } catch {}
            }
          } catch {}
        }
      } catch {}
    })();

    return () => {
      aborted = true;
    };
  }, [fetchUserStats, fetchGamification]);
};

export default useApiVersionSync;
